export const OPTIONS = [
  { value: 'YEAR', label: 'Current Year' },
  { value: 'MONTH', label: 'Current Month' },
  { value: 'NUMBER', label: 'Current Number' },
  { value: 'TEXT1', label: 'Text Field 1' },
  { value: 'TEXT2', label: 'Text Field 2' },
  { value: 'TEXT3', label: 'Text Field 3' }
]

export const YEAR_FORMAT_OPTIONS = [
  { value: 'FULL_YEAR', label: 'Full Year (e.g 2022)' },
  { value: 'SHORT_YEAR', label: 'Short Year (e.g 22)' }
]
export const MONTH_FORMAT_OPTIONS = [
  { value: 'MONTH_NAME', label: 'Month Name (e.g July)' },
  { value: 'PREFIXED_MONTH', label: 'Prefixed Month (e.g 07)' },
  { value: 'SHORT_MONTH', label: 'Short Month (e.g 7)' }
]
export const RESET_EVERY_OPTIONS = [
  { value: 'MONTHLY', label: 'Every Month' },
  { value: 'YEARLY', label: 'Every Year' }
]
